<script lang="ts">
  import BreadCrumbs from "./index.svelte";

  export let paths: { url: string; name: string }[] = [];
  export let title: string;
  export let bg = "#f7f6ff";
  export let textCenter = false;
  export let noMargin = false;
</script>

<div class="title-banner full-width" class:no-mb={noMargin} style={`background-color:${bg};`}>
  <div class="inner" class:text-center={textCenter}>
    {#if $$slots.default}
      <slot />
    {:else if paths?.length}
      <BreadCrumbs {paths} {textCenter}>
        <h1 class="sf-700">{title}</h1>
      </BreadCrumbs>
    {:else}
      <h2 class="sf-700">{title}</h2>
    {/if}
  </div>
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;

  .title-banner {
    display: flex;
    place-content: center;
    height: 100px; // keep as px;
    filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.11));
    padding: 0 1em;
    @include desktop {
      padding: 0 2em;
      margin-bottom: 70px;
      height: 158px;
    }

    &.no-mb {
      margin: 0;
    }

    .inner {
      display: flex;
      flex: 1;
      max-width: 1320px;
      justify-content: center;
      align-items: center;
      @include tablet {
        justify-content: start;
      }

      &.text-center {
        justify-content: center;
      }

      h1 {
        margin: 0;
        font-size: 1.25em;
        line-height: 1.5em; /* 150% */
        @include tablet {
          font-size: 1.85em;
        }
      }
      h2 {
        margin: 0;
      }
    }
  }
</style>
